var util = require('util');
var AbstractIterator = require('abstract-leveldown').AbstractIterator;
var ltgt = require('ltgt');
module.exports = Iterator;
function Iterator(db, options) {
  if (!options) options = {};
  this.options = options;
  AbstractIterator.call(this, db);
  this._order = options.reverse ? 'DESC' : 'ASC';
  this._limit = options.limit;
  this._count = 0;
  this._done = false;
  var lower = ltgt.lowerBound(options);
  var upper = ltgt.upperBound(options);
  try {
    this._keyRange = lower || upper ? this.db.makeKeyRange({
      lower: lower,
      upper: upper,
      excludeLower: ltgt.lowerBoundExclusive(options),
      excludeUpper: ltgt.upperBoundExclusive(options)
    }) : null;
  } catch (e) {
    // The lower key is greater than the upper key.
    // IndexedDB throws an error, but we'll just return 0 results.
    this._keyRangeError = true;
  }
  this.callback = null;
}
util.inherits(Iterator, AbstractIterator);
Iterator.prototype.createIterator = function () {
  var self = this;
  self.iterator = self.db.iterate(function () {
    self.onItem.apply(self, arguments);
  }, {
    keyRange: self._keyRange,
    autoContinue: false,
    order: self._order,
    onError: function onError(err) {
      console.log('horrible error', err);
    }
  });
};

// TODO the limit implementation here just ignores all reads after limit has been reached
// it should cancel the iterator instead but I don't know how
Iterator.prototype.onItem = function (value, cursor, cursorTransaction) {
  if (!cursor && this.callback) {
    this.callback();
    this.callback = false;
    return;
  }
  var shouldCall = true;
  if (!!this._limit && this._limit > 0 && this._count++ >= this._limit) shouldCall = false;
  if (shouldCall) this.callback(false, cursor.key, cursor.value);
  if (cursor) cursor['continue']();
};
Iterator.prototype._next = function (callback) {
  if (!callback) return new Error('next() requires a callback argument');
  if (this._keyRangeError) return callback();
  if (!this._started) {
    this.createIterator();
    this._started = true;
  }
  this.callback = callback;
};